import {getButtonOutlineWhite} from '@hconnect/common/styles'
import {buttonOnBlueSx, mergeSxs} from '@hconnect/uikit/src/lib2'

// inverted (legacy blue surface) keeps the white-on-blue button; otherwise use the neutral token style
export const getExpandCollapseButtonSx = (inverted: boolean) =>
  mergeSxs(inverted ? buttonOnBlueSx : getButtonOutlineWhite, {
    minWidth: {xs: '100%', sm: '150px'}
  })
